import { Frame, FrameLoader, Slide, SlideBody, SlideText, type SlideProps } from '@components'
import { useIsTouch } from '@hooks'
import { useSprings } from '@react-spring/three'
import { useOverlay } from '@stores'
import { useEffect } from 'react'
import type { Vector3Tuple } from 'three'

export function Examples(props: SlideProps) {
  const isTouch = useIsTouch()

  const setLogo = useOverlay(s => s.setLogo)
  const setDemo = useOverlay(s => s.setDemo)

  useEffect(() => {
    setLogo({ position: [-20, 0, 0], rotation: [0, 0, 0] })
    setDemo(undefined)
  }, [setLogo, setDemo])

  const examples = [
    { image: '/images/drysland.png', url: 'https://drysland.dammafra.dev' },
    // { image: '/images/hook-a-fish.png', url: 'https://hook-a-fish.dammafra.dev' },
    { image: '/images/bruno.png', url: 'https://bruno-simon.com' },
    { image: '/images/chartogne.png', url: 'https://chartogne-taillet.com' },
    { image: '/images/cornrevolution.png', url: 'https://cornrevolution.resn.global' },
    { image: '/images/lumen.png', url: 'https://lumen-decor-studio.vercel.app' },
    { image: '/images/messenger.png', url: 'https://messenger.abeto.co' },
  ]

  const [examplesSprings] = useSprings(6, i => {
    const positionsFrom: Vector3Tuple[] = [
      [-20, 0, 0],
      [0, 0, -20],
      [20, 0, 0],
      [-20, 0, 0],
      [0, 0, 20],
      [20, 0, 0],
    ]

    const positionsTo: Vector3Tuple[] = [
      [-3.2, 0, -1.5],
      [0, 0, -1.5],
      [3.2, 0, -1.5],
      [-3, 0, 1.5],
      [0, 0, 1.5],
      [3, 0, 1.5],
    ]

    return {
      from: { position: positionsFrom.at(i), scale: 0.001 },
      to: { position: positionsTo.at(i), scale: i < 3 ? 1 : 0.9 },
      delay: 250,
    }
  })

  return (
    <Slide background={false} {...props}>
      <SlideBody color="white" fontSize={0.3} anchorX="center" position={[3.8, 0, 2.7]}>
        <SlideText fontSize={0.2} anchorY="top">
          👆{`${isTouch ? 'Tap' : 'Double click'} to explore`}
        </SlideText>
        <SlideText>Here's a preview of what you can achieve with Three.js</SlideText>
      </SlideBody>

      <group scale={0.72} position-z={-0.5}>
        {examplesSprings.map((spring, i) => (
          // @ts-expect-error spring typings
          <Frame
            key={`example-${i}`}
            onDoubleClick={() => window.open(examples.at(i)!.url)}
            onClick={() => isTouch && window.open(examples.at(i)!.url)}
            {...spring}
          >
            <FrameLoader src={examples.at(i)!.image} className="size-full object-cover" />
          </Frame>
        ))}
      </group>
    </Slide>
  )
}
